angular
    .module('empower.userProfile')
    .service('userProfileService', ['httpService', '$rootScope','$q','$filter',
        function (httpService, $rootScope, $q, $filter) {
            return {
                getUserProfile: getUserProfile,
                updateProfile: updateProfile,
                updateBankDetails: updateBankDetails,
                deactivateAccount: deactivateAccount
            };

            function getUserProfile() {
                var def = $q.defer();
                var apiTarget = "api/users/profile";
                var values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,                   
                    DateOfBirth: $rootScope.user.DateOfBirth,
                    IsBroker: $rootScope.user.IsBroker,
                    IsEmployer: $rootScope.user.IsEmployer,
                    IsClaimant: $rootScope.user.IsClaimant
                });     
                httpService.httpRequest(apiTarget, values).then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }

            function updateProfile(profile) {
                var def = $q.defer();
                var apiTarget = "api/users/profile";
                var values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    FirstName: profile.FirstName,
                    MiddleName: profile.MiddleName,
                    LastName: profile.LastName,
                    HomePhone: profile.HomePhone,
                    WorkPhone: profile.WorkPhone,
                    MobilePhone: profile.MobilePhone,
                    AccountName: profile.AccountName,
                    BankName: profile.BankName,
                    AccountNumber: profile.AccountNumber,
                    Street: profile.Street,
                    Suburb: profile.Suburb,
                    State: profile.State,                  
                    PostCode: profile.PostCode,
                    PostalStreet: profile.SameAsAddress == true ? profile.Street : profile.PostalStreet,
                    PostalSuburb: profile.SameAsAddress == true ? profile.Suburb : profile.PostalSuburb,
                    PostalState: profile.SameAsAddress == true ? profile.State : profile.PostalState,
                    PostalPostCode: profile.SameAsAddress == true ? profile.PostCode : profile.PostalPostCode,
                    SameAsAddress: profile.SameAsAddress,
                    PreferredContactNumnerType: profile.PreferredContactNumnerType,
                    PreferredCommunicationType: profile.PreferredCommunicationType,
                    PreferredTimeToContact: profile.PreferredTimeToContact,
                    ProfileId: profile.ProfileId,
                    DateOfBirth: $rootScope.user.DateOfBirth,
                    IsBroker: $rootScope.user.IsBroker,
                    IsEmployer: $rootScope.user.IsEmployer,
                    IsClaimant: $rootScope.user.IsClaimant,
                });  
                httpService.httpRequest(apiTarget, values,'POST').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }


            function updateBankDetails(profile) {
                var def = $q.defer();
                var apiTarget = "api/users/profile";
                var values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),
                    AccountName: profile.AccountName,
                    //BankName: profile.BankName,
                    BSBNumber: profile.BSBNumber,
                    AccountNumber: profile.AccountNumber,                   
                    ProfileId: $rootScope.profileId,
                    IsUpdateBankDetails: true,
                    DateOfBirth: $rootScope.user.DateOfBirth,                  
                    IsClaimant: $rootScope.user.IsClaimant,
                });  
                httpService.httpRequest(apiTarget, values,'POST').then(function (result) {
                    def.resolve(angular.fromJson(result));
                });
                return def.promise;
            }

            function deactivateAccount() {
                var def = $q.defer();
                var apiTarget = "api/users/deactivateAccount";
                var values = JSON.stringify({
                    Identifier: $rootScope.user.Identifier,
                    SessionKey: $filter('decstr64')($rootScope.user.SessionKey),           
                    IsClaimant: $rootScope.user.IsClaimant
                });  
                httpService.httpRequest(apiTarget, values,'POST').then(function (data) {
                    if (data !== false) {
                        if (data === "logout") {
                            $rootScope.userLogout();
                        }
                        def.resolve(angular.fromJson(data));
                    } else {
                        def.reject();
                    }
                });
                return def.promise;
            }
        }
    ]);